var _rect, _rect2, _path, _text, _circle, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultProject(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 80,
    viewBox: "0 0 200 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 80,
    rx: 8,
    fill: "#E0E7FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 15,
    width: 160,
    height: 50,
    rx: 6,
    fill: "#C7D2FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 25L45 35L35 45V25Z",
    fill: "#818CF8"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 47,
    fontFamily: "Arial, sans-serif",
    fontSize: 20,
    fontWeight: 600,
    fill: "#4F46E5",
    textAnchor: "middle"
  }, "Project")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 155,
    cy: 35,
    r: 8,
    fill: "#818CF8",
    opacity: 0.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 165,
    cy: 35,
    r: 8,
    fill: "#818CF8",
    opacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultProject);
export default __webpack_public_path__ + "static/media/default-project.85f121bf5cc732076861cfe681f9f6fe.svg";
export { ForwardRef as ReactComponent };